import React, { useEffect, useState } from "react";
import ApplicationInformation from "../../Pages/Manager/ApplicationInformation";
import { GetSpecificTaskById } from "../../Redux/Reducers/Manager/Tasks/TasksByRoundAndFiled";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Marks from "../../Pages/Manager/Marks";
import {
  ChangeStatusSubTasks,
  GetSpecificRowSubTask,
} from "../../Redux/Reducers/Manager/SubTask";
import ActionOnApplication from "../../Pages/Manager/ActionOnApplication";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import ButtonAHSF from "../../Components/ButtonAHSF";
import {
  GetFlowActionByTaskId,
  UpdateActionFlowForSubTasks,
} from "../../Redux/Reducers/Manager/FlowAction";
import {
  UpdateAllMarks,
  ValidationMarks,
} from "../../Redux/Reducers/Manager/Marks";
import Swal from "sweetalert2";

function EvaluationInformation() {
  const [ActionReason, setActionReason] = useState(false);
  const userInfo = useSelector((state) => state.UserInfo.UserInfo.userToken);
  const [AdditionalNotes, setAdditionalNotes] = useState(null);
  const [EditNotes, setEditNotes] = useState("");

  const [RecommendationId, setRecommendationId] = useState(null);
  const [Attachment, setAttachment] = useState(false);
  const [TaskDisabledStatus, setTaskDisabledStatus] = useState(false);
  const [EditApplicationButtonShow, setEditApplicationButtonShow] =
    useState(false);
  const [disabled, SetDisabled] = useState(true);
  const [EndInitialEvaluationButtonShow, setEndInitialEvaluationButtonShow] =
    useState(false);
  const { subTaskId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const applicationGuid = useSelector(
    (state) => state.SubTaskReducer.SubTaskRow
  );
  const SpecificRowSubTask = useSelector(
    (status) => status.SubTaskReducer.SubTaskRow
  );
  const ResultChangeStatusSubTasks = useSelector(
    (state) => state.SubTaskReducer.ChangeStatusResult
  );
  const FlowActionSpecificRow = useSelector(
    (state) => state.FlowActionByTaskId.FlowActionByTaskId
  );
  useEffect(() => {
    dispatch(GetSpecificRowSubTask({ subTaskId: subTaskId }));
  }, [subTaskId, ResultChangeStatusSubTasks]);

  const state = useSelector((state) => {
    return {
      MarksManagerValidation: state.MarksManager.MarksManagerValidation,
    };
  });

  const [MarksData, setMarksData] = useState({});
  console.log(SpecificRowSubTask, "ssss");

  const CangeStatusReturnEdit = async () => {
    const allMarksItems = Object.values(MarksData).flatMap(
      (group) => group.value
    );
    let resultUpdateMarksList = await dispatch(
      UpdateAllMarks({
        eV_NT_MarksEvaluationModel: allMarksItems,
      })
    );
    let resultValidation = await dispatch(
      ValidationMarks({ taskId: subTaskId })
    );
    UpdateActionFlowForSubTasksfunction();
    if (resultUpdateMarksList.payload.success) {
      if (
        resultValidation.payload.length === 0 &&
        AdditionalNotes != null &&
        AdditionalNotes != "" &&
        RecommendationId != null
      ) {
        await dispatch(
          ChangeStatusSubTasks({
            subTaskId: subTaskId,
            statusChange: "715e2ea3-5767-491f-943e-78f4212d506c",
          })
        );
        // navigate("/SRFund/manager/RequestsEvaluation/");
      } else {
        const missingFields = [];

        if (!AdditionalNotes) missingFields.push("الملاحظات الاضافية");
        if (!RecommendationId) missingFields.push("التوصية النهائية");

        let concatArry = [];
        if (missingFields.length > 0) {
          concatArry = [...resultValidation.payload, ...missingFields];
        } else {
          concatArry = resultValidation.payload;
        }
        Swal.fire({
          title: "الرجاء تعبئة الحقول التالية",
          html: `
              <div style="text-align: right; direction: rtl; font-size: 16px;">
                <ul style="list-style-type: none; padding: 0;">${concatArry
                  .map(
                    (msg) =>
                      `<li style="margin-bottom: 8px;">🔸 <strong>${msg}</strong></li>`
                  )
                  .join("")}</ul>`,
          icon: "warning",
          confirmButtonText: "حسناً",
        });
      }
    }
  };
  const Save = async () => {
    const allMarksItems = Object.values(MarksData).flatMap(
      (group) => group.value
    );
    let resultUpdateMarksList = await dispatch(
      UpdateAllMarks({
        eV_NT_MarksEvaluationModel: allMarksItems,
      })
    );
    Swal.fire({
      position: "center",
      icon: "success",
      title: "تم الحفظ بنجاح",
      showConfirmButton: false,
      timer: 1500,
    });
  };
  const CompletionInitialAssessment = async () => {
    const allMarksItems = Object.values(MarksData).flatMap(
      (group) => group.value
    );

    let resultUpdateMarksList = await dispatch(
      UpdateAllMarks({
        eV_NT_MarksEvaluationModel: allMarksItems,
      })
    );
    let resultValidation = await dispatch(
      ValidationMarks({ taskId: subTaskId })
    );
    UpdateActionFlowForSubTasksfunction();
    if (resultUpdateMarksList.payload.success) {
      if (
        resultValidation.payload.length === 0 &&
        AdditionalNotes != null &&
        AdditionalNotes != "" &&
        RecommendationId != null
      ) {
        await dispatch(
          ChangeStatusSubTasks({
            subTaskId: subTaskId,
            statusChange: "11145df2-6455-4c46-94a3-70ea2ac14367",
          })
        );
        navigate("/SRFund/manager/RequestsEvaluation/");
      } else {
        let missingFields = [];
        if (!AdditionalNotes || AdditionalNotes == "")
          missingFields.push("الملاحظات الاضافية");
        if (!RecommendationId) missingFields.push("التوصية النهائية");

        let concatArray = [];

        if (missingFields.length > 0) {
          if (resultValidation.payload.length > 0) {
            concatArray = [...resultValidation.payload, ...missingFields];
          } else {
            concatArray = missingFields;
          }
          // concatArray = [...resultValidation.payload, ...missingFields];
        } else {
          concatArray = resultValidation.payload;
        }
        console.log(concatArray, "missingFields");

        Swal.fire({
          title: "الرجاء  الحقول التالية",
          html: `
              <div style="text-align: right; direction: rtl; font-size: 16px;">
                <ul style="list-style-type: none; padding: 0;">${concatArray
                  .map(
                    (msg) =>
                      `<li style="margin-bottom: 8px;">🔸 <strong>${msg}</strong></li>`
                  )
                  .join("")}</ul>`,
          icon: "warning",
          confirmButtonText: "حسناً",
        });
      }
    }
  };
  useEffect(() => {
    if (
      //الانتهاء من التقييم الأولي
      SpecificRowSubTask?.taskStatusId ==
        "715e2ea3-5767-491f-943e-78f4212d506c" &&
      SpecificRowSubTask.userId == userInfo.userGuid
    ) {
      SetDisabled(false);
      setEndInitialEvaluationButtonShow(true);
      setEditApplicationButtonShow(false);
    } else if (
      //التعديل على التقييم
      SpecificRowSubTask?.taskStatusId ==
        "11145df2-6455-4c46-94a3-70ea2ac14367" &&
      SpecificRowSubTask.userId == userInfo.userGuid
    ) {
      SetDisabled(true);
      setEditApplicationButtonShow(true);
      setEndInitialEvaluationButtonShow(false);
    }
  }, [SpecificRowSubTask]);

  useEffect(() => {
    if (subTaskId != null) {
      dispatch(
        GetFlowActionByTaskId({
          mainTaskId: null,
          subTaskId: subTaskId,
        })
      );
    }
  }, [subTaskId, ResultChangeStatusSubTasks]);

  const UpdateActionFlowForSubTasksfunction = () => {
    dispatch(
      UpdateActionFlowForSubTasks({
        flowActionId: FlowActionSpecificRow.flowActionId,
        taskId: null,
        recommendationId: RecommendationId,
        applicationInformationId:
          FlowActionSpecificRow?.applicationInformationId,
        isSubTask: true,
        subTaskId: FlowActionSpecificRow?.subTaskId,
        actionReason: null,
        additionalNote: AdditionalNotes,
        editNotes:EditNotes,
        actionAttacment: null,
      })
    );
  };

  useEffect(() => {
    setAdditionalNotes(FlowActionSpecificRow?.additionalNote);
    setRecommendationId(FlowActionSpecificRow?.recommendationId);
    setEditNotes(FlowActionSpecificRow?.editNotes)
  }, [FlowActionSpecificRow]);

  console.log(FlowActionSpecificRow,"ssssssssdwdwwwwwwwwwwddd");

  return (
    <>
    {FlowActionSpecificRow?.applicationInformationId ? (
        <>
      <ApplicationInformation
        applicationGuid={applicationGuid?.applicationInformationId}
      />
      <Marks
        disabled={disabled}
        taskId={subTaskId}
        onDataChange={(updatedData) => setMarksData(updatedData)}
      />

      
          <SharedDiv
            showTitle={true}
            titleName="الإجراءات على الطلب"
            child={[
              <>
                <ActionOnApplication
                  Recommendation={true}
                  setAttachment={setAttachment}
                  // Attachment={ComponentRoundByFlow?.includes(
                  //   "4f90a961-372a-4973-8043-65fb7c3e2d58"
                  // )}
                  // Reason={ComponentRoundByFlow?.includes(
                  //   "c5f49e37-997b-4bef-a8df-571791dc6d6a"
                  // )}
                  // AdditionalNotes={ComponentRoundByFlow?.includes(
                  //   "0bed9655-e693-4493-bc43-1363b9f99304"
                  // )}
                  // FlowActionSpecificRow={FlowActionSpecificRow}
                  AdditionalNotesData={FlowActionSpecificRow?.additionalNote}
                  RecommendationIdData={FlowActionSpecificRow?.recommendationId}
                  EditNoteData={FlowActionSpecificRow?.editNotes}
                  EditNote={true}
                  AdditionalNotes={true}
                  actionGuid={""}
                  setActionReason={setActionReason}
                  setRecommendationId={setRecommendationId}
                  setAdditionalNotes={setAdditionalNotes}
                  setEditNotes={setEditNotes}
                  FieldId={""}
                  RoundId={""}
                  disabled={disabled}
                  show={true}
                />
              </>,
            ]}
          />


          
        



      

      {EditApplicationButtonShow || EndInitialEvaluationButtonShow ? (
        <div className="containersButton">
          <div>
            <ButtonAHSF
              type={"submitter"}
              onClick={
                EditApplicationButtonShow
                  ? CangeStatusReturnEdit
                  : EndInitialEvaluationButtonShow
                  ? CompletionInitialAssessment
                  : () => {}
              }
              disabled={false}
              // title={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
              text={
                EditApplicationButtonShow
                  ? "التعديل على التقييم"
                  : "إنهاء التقييم الأولي"
              }
              show={true}
            />
          </div>
          {EndInitialEvaluationButtonShow ? (
            <>
              <div className="SaveButtonMarks">
                <ButtonAHSF
                  type={"submitter"}
                  onClick={Save}
                  disabled={false}
                  // title={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                  text={"حفظ"}
                  show={true}
                />
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      ) : (
        <></>
      )}
      </>
      ) : (
        <></>
      )}

    </>
  );
}

export default EvaluationInformation;
